module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Dossier")]), _vm._v(" "), (_vm.values) ? _c('table', [_vm._m(0), _vm._v(" "), _vm._l((_vm.values), function(v, k, i) {
    return _c('tr', [_c('td', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.getQuestionContent(k))
      }
    })]), _vm._v(" "), _c('td', {
      domProps: {
        "innerHTML": _vm._s(_vm.getResponse(v, k, i))
      }
    })])
  })], 2) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Question")]), _c('th', [_vm._v("Réponse")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f4d435a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/screens/ScreenAdmin.vue
// module id = 735
// module chunks = 3